import React, { useState } from "react";
import "./news/news.css";
import { Navigation } from "../components/navigation";
import { Footer } from "../components/footer";
import { newsPosts } from "../data/contentIndex";

const NewsPage = () => {
  const [expandedPosts, setExpandedPosts] = useState({});

  const toggleDescription = (title) =>
    setExpandedPosts((prev) => ({ ...prev, [title]: !prev[title] }));

  return (
    <>
      <Navigation />
      <div className="news-page">
        <div className="news-page__content">
          <div className="news-section-title">
            <h2>နောက်ဆုံး သတင်းများ</h2>
          </div>
          <section className="news-grid">
            {newsPosts.map((post) => {
              const isExpanded = Boolean(expandedPosts[post.title]);
              return (
                <article key={post.title} className="news-post-card">
                  <h2 className="news-post-card__title">{post.title}</h2>
                  <img
                    src={post.image}
                    alt={post.title}
                    className="news-post-card__image"
                  />
                  <div className="news-post-card__content">
                    <p
                      className={`news-post-card__excerpt ${
                        isExpanded ? "is-expanded" : ""
                      }`}
                    >
                      {post.description}
                    </p>
                    <button
                      type="button"
                      className="news-post-card__readmore"
                      onClick={() => toggleDescription(post.title)}
                    >
                      {isExpanded ? "Show less" : "read more"}
                    </button>
                  </div>
                </article>
              );
            })}
          </section>
          <div className="news-load-more">
            <button type="button" className="news-load-more__button">
              Load More
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsPage;
